import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Button } from '@mui/material';

import CloneTemplate from 'pages/cloneTemplate';
import EditTemplate from 'pages/editTemplate';
import NewTemplate from 'pages/newTemplate';
import Home from 'pages/home';
import Templates from 'pages/templates';
import { Paths } from 'routes';
import { useAuth0 } from '@auth0/auth0-react';

const App: React.FC = () => {
  const { isLoading, isAuthenticated, error, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Oops... {error.message}</div>;
  }
  if (isAuthenticated) {
    return (
      <Routes>
        <Route path={Paths.root} element={<Home />} />
        <Route path={Paths.templates} element={<Templates />} />
        <Route path={Paths.newTemplate} element={<NewTemplate />} />
        <Route path={Paths.template} element={<EditTemplate />} />
        <Route path={Paths.cloneTemplate} element={<CloneTemplate />} />
      </Routes>
    );
  } else {
    return (
      <Button variant="contained" onClick={() => loginWithRedirect()}>
        Log In
      </Button>
    );
  }
};

export default App;
